import styled from 'styled-components'

export const StyledStepSegments = styled.div`
  height: 100%;
  .ant-form {
    height: 100%;
  }
`
